import { Api } from '@axiom/ui';
import type { BarredLocation } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';
import LegacyApiHelper from '../classes/legacy-api-helper';

const api = new LegacyApiHelper('barred location');

export const getBarredLocations = async () => {
  const { data, _meta } = await api.GET('/barredLocations');
  return {
    data,
    meta: _meta,
  };
};

class BarredLocationApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.clientApiBase,
    });
  }

  readBarredLocations() {
    return super.read<{ data: BarredLocation[] }>({
      endpoint: '/barredLocations',
      method: 'GET',
    });
  }
}

export const BarredLocationApi = new BarredLocationApiClass();
